import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum ECompareFlightTooltipTypes {
  SetCompareFlightModalOpen = 'compareFlightTooltip/SetCompareFlightModalOpen',
}

export type TSetCompareFlightModalOpen = ITypedReduxAction<
  ECompareFlightTooltipTypes.SetCompareFlightModalOpen,
  boolean
>;

export const setCompareFlightModalOpen = actionGenerator<ECompareFlightTooltipTypes.SetCompareFlightModalOpen, boolean>(
  ECompareFlightTooltipTypes.SetCompareFlightModalOpen,
);

export type TCompareFlightTooltipActions = TSetCompareFlightModalOpen;
